import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=79947bb2"
import script from "./Dialog.ts?vue&type=script&lang=ts&external"
export * from "./Dialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports